/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_In_Reason_From_PurchaseInputs */

const vi_pkl_in_reason_from_purchase = /** @type {(inputs: Pkl_In_Reason_From_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ đơn mua NCC`)
};

/**

* @param {Pkl_In_Reason_From_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_in_reason_from_purchase = /** @type {((inputs?: Pkl_In_Reason_From_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_In_Reason_From_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_in_reason_from_purchase(inputs)
});